import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import CourtOwnerSidebar from "../../components/courtowner/CourtOwnerSidebar";

const API_BASE = "https://api.getfitindia.in/api";

function AddVenue() {
  const navigate = useNavigate();
  const fileInputRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [venue, setVenue] = useState({
    name: "",
    city: "",
    location: { address: "", lat: "", lng: "" },
    description: "",
    pricing: "",
    image: null,
    sports: "",
    amenities: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    const formData = new FormData();
    formData.append("name", venue.name);
    formData.append("city", venue.city);
    formData.append("location[address]", venue.location.address || "");
    formData.append("location[lat]", venue.location.lat || "");
    formData.append("location[lng]", venue.location.lng || "");
    formData.append("pricing", venue.pricing);
    formData.append("description", venue.description);
    formData.append("image", venue.image);
    formData.append("sports", venue.sports);
    formData.append("amenities", venue.amenities);

    try {
      const token = localStorage.getItem("courtOwnerToken");
      if (!token) {
        alert("You must be logged in as a court owner!");
        setIsSubmitting(false);
        return;
      }

      const res = await fetch(`${API_BASE}/courtowner/venues/owner`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      if (res.ok) {
        alert("✅ Venue Added Successfully!");
        setVenue({
          name: "",
          city: "",
          location: { address: "", lat: "", lng: "" },
          description: "",
          pricing: "",
          image: null,
          sports: "",
          amenities: "",
        });
        if (fileInputRef.current) fileInputRef.current.value = "";
        navigate("/courtowner/venues");
      } else {
        const err = await res.json();
        alert(`❌ Failed to add venue: ${err.message || "Unknown error"}`);
      }
    } catch (err) {
      console.error(err);
      alert("❌ Something went wrong. Check console for details.");
    }

    setIsSubmitting(false);
  };

  return (
  <div className="min-h-screen bg-[#f7f8fb]">

  {/* FIXED SIDEBAR (DESKTOP) */}
  <aside className="hidden lg:block fixed inset-y-0 left-0 w-64 bg-white shadow z-30">
    <CourtOwnerSidebar />
  </aside>

  {/* MAIN AREA */}
  <main className="lg:pl-64">

    {/* HEADER */}
    <div className="bg-[#0f2250] text-white sticky top-0 z-20 py-2">
      <div className="max-w-6xl mx-auto px-4 py-4 flex items-center gap-4">

        {/* MOBILE SIDEBAR */}
        <div className="lg:hidden">
          <CourtOwnerSidebar />
        </div>

        <h1 className="text-lg font-semibold  sm:ms-0 md:ms-16 lg:ms-0">
          Add New Venue
        </h1>
      </div>
    </div>

    {/* PAGE CONTENT */}
    <div className="max-w-6xl mx-auto px-4 py-6">

      <form
        onSubmit={handleSubmit}
        className="max-w-2xl mx-auto bg-[#ebeef1] shadow-[0_0_6px_rgba(0,0,0,0.2)] rounded-2xl p-6 sm:p-8"
      >
        {/* ⭐ YOUR EXISTING FORM CONTENT GOES HERE ⭐ */}
        <div className="space-y-4">

          {/* Venue Name */}
          <div>
            <label className="text-sm text-gray-600 block mb-1 capitalize">Venue Name</label>
            <input
              type="text"
              placeholder="Enter venue name"
              className="w-full bg-[#f3f4f6] border border-gray-300 rounded-md py-2 px-3 focus:ring-2 focus:ring-[#0d2149] focus:outline-none text-sm"
              value={venue.name}
              onChange={(e) => setVenue({ ...venue, name: e.target.value })}
            />
          </div>

          {/* City */}
          <div>
            <label className="text-sm text-gray-600 block mb-1 capitalize">City</label>
            <input
              type="text"
              placeholder="Enter city name"
              className="w-full bg-[#f3f4f6] border border-gray-300 rounded-md py-2 px-3 focus:ring-2 focus:ring-[#0d2149] focus:outline-none text-sm"
              value={venue.city}
              onChange={(e) => setVenue({ ...venue, city: e.target.value })}
            />
          </div>

          {/* Address */}
          <div>
            <label className="text-sm text-gray-600 block mb-1">Address</label>
            <textarea
              placeholder="Full address..."
              rows={3}
              className="w-full bg-[#f3f4f6] border border-gray-300 rounded-md py-2 px-3 resize-none focus:ring-2 focus:ring-[#0d2149] focus:outline-none text-sm"
              value={venue.location.address}
              onChange={(e) =>
                setVenue({
                  ...venue,
                  location: { ...venue.location, address: e.target.value },
                })
              }
            />
          </div>

          {/* Latitude / Longitude */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="text-sm text-gray-600 block mb-1">Latitude</label>
              <input
                type="number"
                placeholder="Latitude"
                className="w-full bg-[#f3f4f6] border border-gray-300 rounded-md py-2 px-3 focus:ring-2 focus:ring-[#0d2149] focus:outline-none text-sm"
                value={venue.location.lat}
                onChange={(e) =>
                  setVenue({
                    ...venue,
                    location: { ...venue.location, lat: e.target.value },
                  })
                }
              />
            </div>

            <div>
              <label className="text-sm text-gray-600 block mb-1">Longitude</label>
              <input
                type="number"
                placeholder="Longitude"
                className="w-full bg-[#f3f4f6] border border-gray-300 rounded-md py-2 px-3 focus:ring-2 focus:ring-[#0d2149] focus:outline-none text-sm"
                value={venue.location.lng}
                onChange={(e) =>
                  setVenue({
                    ...venue,
                    location: { ...venue.location, lng: e.target.value },
                  })
                }
              />
            </div>
          </div>

          {/* Sports */}
          <div>
            <label className="text-sm text-gray-600 block mb-1 capitalize">Sports</label>
            <input
              type="text"
              placeholder="e.g. Football, Badminton"
              className="w-full bg-[#f3f4f6] border border-gray-300 rounded-md py-2 px-3 focus:ring-2 focus:ring-[#0d2149] focus:outline-none text-sm"
              value={venue.sports}
              onChange={(e) => setVenue({ ...venue, sports: e.target.value })}
            />
          </div>

          {/* Amenities */}
          <div>
            <label className="text-sm text-gray-600 block mb-1 capitalize">Amenities</label>
            <input
              type="text"
              placeholder="e.g. Parking, Changing Room"
              className="w-full bg-[#f3f4f6] border border-gray-300 rounded-md py-2 px-3 focus:ring-2 focus:ring-[#0d2149] focus:outline-none text-sm"
              value={venue.amenities}
              onChange={(e) => setVenue({ ...venue, amenities: e.target.value })}
            />
          </div>

          {/* Image Upload */}
          <div>
            <label className="text-sm text-gray-600 block mb-1">Upload Image</label>
            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              className="w-full bg-[#f3f4f6] border border-gray-300 rounded-md py-[6px] px-3 text-sm focus:ring-2 focus:ring-[#0d2149]"
              onChange={(e) =>
                setVenue({ ...venue, image: e.target.files[0] })
              }
            />
          </div>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          disabled={isSubmitting}
          className={`mt-6 w-full py-2 rounded-md text-sm font-semibold transition ${
            isSubmitting
              ? "bg-gray-400 cursor-not-allowed text-white"
              : "bg-[#043f6e] text-white hover:bg-[#075aae]"
          }`}
        >
          {isSubmitting ? "Saving..." : "Add Venue"}
        </button>

      </form>
    </div>

  </main>
</div>

  );
}

export default AddVenue;
